/* @flow */

import React, { type Node } from 'react';
import { Root } from './styles';

type TProps = {
	type?: string,
	statical?: boolean,
	height?: number,
	main?: boolean,
	noImage?: boolean,
	children: Node,
};

const Tile = ({ type, statical, children, main, height, noImage }: TProps) => (
	<Root style={{ height: height || (!!main && 245) }} $type={type} $static={statical} $noImage={noImage}>
		{children}
	</Root>
);

Tile.defaultProps = {
	type: 'normal',
	statical: false,
	main: false,
	height: null,
	noImage: false,
};

export default Tile;
